import { IWithIsActive } from '@/screens/DestinationsPage/domain/Destination.domain';
import { DropdownArrow } from '@/shared/images/icons/DropdownArrow';
import { cssVars } from '@/styles/Themes/cssVars';
import { Transition } from '@/styles/Themes/KeyFrames';
import { radius } from '@/styles/Themes/Metrics';
import Palette from '@/styles/Themes/Palette';
import Screen from 'src/styles/Themes/Screen';
import Text from 'src/styles/Themes/Text';
import styled, { css, DefaultTheme } from 'styled-components';

export const Container = styled.div`
    display: grid;
    grid-gap: 12px;
    grid-template-columns: 1fr 1fr;

    position: relative;
    margin-bottom: 20px;
    width: 100%;

    ${Screen.ipad} {
        margin-bottom: 24px;
        grid-gap: 30px;
    }
    ${Screen.desktop} {
        grid-template-columns: repeat(4, 1fr);
    }
`;

export const Box = styled.div`
    height: 144px;

    ${Screen.ipad} {
        height: 250px;
    }
    ${Screen.desktop} {
        height: 244px;
    }

    &:hover {
        box-shadow: ${cssVars.shadow_card_hover};
        ${Transition.normal};
    }
`;

export const Row = styled.div`
    width: 100%;
    border-radius: ${radius.small};
    padding: 16px 0 0;
    cursor: pointer;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    overflow: hidden;

    ${Screen.ipad} {
        padding: 20px 0 22px;
    }
    ${Screen.desktop} {
        padding: 0;
        cursor: default;
        max-width: 1124px;
        padding: 20px 0 0;
    }
`;

export const Title = styled.h3`
    color: ${cssVars.fg_gray1_white};
    margin: 0 0 18px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    z-index: 1;
    ${Text.Mobile.medium.medium}

    ${Screen.ipad} {
        ${Text.Ipad.medium.medium}
        margin: 0 0 33px;
    }

    ${Screen.desktop} {
        ${Text.Desktop.heading2};
        margin-bottom: 20px;
    }
`;

export const Arrow = styled(DropdownArrow)<IWithIsActive>`
    ${({ isActive }) => isActive && 'transform: rotate(-180deg);'}
    ${Transition.arrow};
`;

export const Link = styled.a`
    color: ${({ theme }) => theme.fg.green.main};
    ${css`
        ${Text.Mobile.medium.semibold}
        ${Screen.ipad} {
            ${Text.Ipad.heading4}
        }
        ${Screen.desktop} {
            ${Text.Desktop.large.semibold}
        }
    `}
    :active, :hover {
        color: ${({ theme }) => theme.fg.green.second};
    }
`;

export const Description = styled.span`
    color: ${({ theme }) => theme.fg.gray.main};
    width: 100%;
    ${css`
        ${Text.Mobile.medium.medium}
        ${Screen.ipad} {
            ${Text.Ipad.medium.medium}
        }
        ${Screen.desktop} {
            ${Text.Desktop.large.medium}
        }
    `}
`;

export const Grid = styled.div`
    display: grid;
    grid-template: 1fr 1fr 1fr / 1fr 1fr;
    grid-gap: 12px;

    *:first-child {
        grid-column-start: 1;
        grid-column-end: 3;
        grid-row-start: 1;
        grid-row-end: 3;
    }

    height: 492px;
    margin-bottom: 30px;

    min-width: calc(100vw - 36px);

    ${Screen.ipad} {
        min-width: calc(100vw - 60px);
        height: 705px;
        grid-gap: 30px;
        margin-bottom: 40px;
    }
    ${Screen.desktop} {
        min-width: 100%;
        max-width: 1366px;
        height: 520px;
        grid-template: 1fr 1fr / repeat(4, 1fr);

        *:first-child {
            grid-column-start: 1;
            grid-column-end: 3;
            grid-row-start: 1;
            grid-row-end: 3;
        }

        *:nth-child(2) {
            grid-column-start: 3;
            grid-column-end: 5;
        }

        margin-bottom: 25px;
    }
`;

export const BtnContainer = styled.div`
    padding: 0 28px;

    *:first-child {
        display: none;
    }

    ${Screen.desktop} {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        padding: 0;

        *:first-child {
            display: block;
        }

        *:last-child {
            max-width: 250px;
        }
    }
`;

interface TGallery extends DefaultTheme {
    page: number;
}

export const Gallery = styled.div<TGallery>`
    transform: ${(props) => `translateX(-${props.page}00vw)`};
    transition: 0.5s ease 0s;
    width: auto;
    display: flex;
    user-select: none;

    gap: 36px;
    ${Screen.ipad} {
        gap: 60px;
    }
    ${Screen.full} {
        transform: ${(props) => `translateX(-${1426 * props.page}px)`};
    }
`;

export const ButtonViewMore = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 50px;
    background-color: ${cssVars.bg_ash_normal};
    border-radius: 0px 0px 15px 15px;
    margin-bottom: 20px;
    border: none;
    cursor: pointer;
    color: ${cssVars.fg_gray2_gray3};
    ${Text.Full.large.medium};

    > svg {
        stroke: ${Palette.green.normal};
    }

    ${Screen.ipad} {
        margin-bottom: 0;
    }

    ${Screen.desktop} {
        background-color: ${cssVars.bg_ash_blueDark};
        margin-bottom: 24px;
    }
`;
